<template>
  <div>
    <BaseListPage
        :name="name"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        :min-column-width="'140px'"
        :async-render="true"
        :show-pagination="true"
        :is-max-get-count="false"
        :sumTableList="sumTableRows"
        :sumDisplayList="sumDisplayRows"
        title="販売売上レポート(デジタル)：期間分析(エール別)"
        title-class="sales-header"
        icon="report">
      <span
          slot="headerAction"
          class="action_button">
        <span>
          <el-button
              id="displayTax"
              class="displayTax"
              size="small"
              @click="displayTax">
            {{ displayTax.textContent }}税込計算
          </el-button>
        </span>
        <el-dropdown
            v-show="showActionList">
          <el-button size="small">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <ToDownload
                ref="download"
                page-key="sales_yell_list"
                :conditions="conditions"
                :keyword="searchKeyword"
                :is-and-search="isAndSearch" />
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </BaseListPage>
  </div>
</template>

<script>
/* eslint-disable no-console */
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/sales'
import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/pages/report/sales/SalesBaseListPage'
import ToDownload from '@/components/organisms/ToDownload'

export default {
  name: 'SalesYellDigitalList',
  components: {
    BaseListPage,
    ToDownload
  },
  mixins: [ x, orderUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isDisplaySelectDialog: false,
      localIsParentLoaded: false,
      showActionList: false,
      isDisplayTax: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.SalesYell.listIndex,
      tableSetList: (state) => state.SalesYell.tableSetList,
      searchKeyword: (state) => state.SalesYell.searchKeyword || '',
      isAndSearch: (state) => state.SalesYell.isAndSearch || false,
      conditions: (state) => state.SalesYell.searchConditions || {},
      tdLists: (state) => state.SalesYell.tdLists,
      sites: (state) => state.sites
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig',
      searchConditions: 'searchConditions'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'SalesYellDigitalList'
    },
    storePath () {
      return 'SalesYell'
    },
    saveKey () {
      return 'salesYellCondition'
    },
    responsePath () {
      return 'data.salesYellLists.edges'
    },
    returnPath () {
      return '/report/salesYell'
    },
    baseQuery () {
      return 'query { ' + query.GRAPH_QL_QUERY_SALES_YELL +
       query.GRAPH_QL_QUERY_SALES_YELL_LIST +
       '}}'
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      const taxMode = (this.isDisplayTax ? 'Gross' : 'Net')
      const taxlabel = (this.isDisplayTax ? '(税込)' : '(税抜)')
      const productPagesflg = this.$isFunctionShown(define.PermissionKeys.PRODUCT) &&
        this.$isFunctionShown(define.PermissionKeys.Product.DETAIL)
      const returnValue = [
        {
          itemKey: 'groupUnitMonth', isAvailable: false, isActive: false,
          type: 'String', label: '月', path: 'node.Month', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.GROUPBY_MONTH
        },
        {
          itemKey: 'groupUnitDay', isAvailable: false, isActive: false,
          type: 'String', label: '日', path: 'node.Day', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.GROUPBY_DAY
        },
        {
          itemKey: 'groupUnitPaymentMethod', isAvailable: false, isActive: false,
          type: 'String', label: '支払方法', path: 'node.PaymentMethod', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.GROUPBY_PAYMENTMETHOD
        },
        {
          itemKey: 'groupUnitSite', isAvailable: false, isActive: false,
          type: 'String', label: 'サイト', path: 'node.Site', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.GROUPBY_SITE
        },
        {
          itemKey: 'productCode', isAvailable: true, isActive: true,
          type: 'String', label: '商品コード', path: 'node.productCode', sortable: 'custom',
          elementType: productPagesflg ? ELEMENT_TYPE.LINK : ELEMENT_TYPE.INPUT,
          class: 'visitedlinkNoChangeColor', linkKey: 'node.productUuid', linkPath: '/product/',
          onLinkClick: (key, keyPath) => { this.$_mixin_onLinkClick(-1, 'Product') },
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.PRODUCT_CODE
        },
        {
          itemKey: 'productName', isAvailable: true, isActive: true,
          type: 'String', label: '商品名', path: 'node.productName', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.PRODUCT_NAME
        },
        {
          itemKey: 'variationName', isAvailable: true, isActive: true,
          type: 'String', label: 'バリエーション名', path: 'node.variationName',
          sortable: 'custom', width: 160,
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.VARIATION_NAME
        },
        {
          itemKey: 'artistCode', isAvailable: true, isActive: true,
          type: 'String', label: 'アーティストコード', path: 'node.artistCode',
          sortable: 'custom', width: 180,
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.ARTIST_CODE
        },
        {
          itemKey: 'artistName', isAvailable: true, isActive: true,
          type: 'String', label: 'アーティスト名', path: 'node.artistName',
          sortable: 'custom', width: 150,
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.ARTIST_NAME
        },
        {
          itemKey: 'orderCnt', isAvailable: true, isActive: true,
          type: 'Number', label: '注文件数', path: 'node.orderCnt', sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.ORDER_CNT
        },
        {
          itemKey: 'quantity', isAvailable: true, isActive: true,
          type: 'Number', label: '数量', path: 'node.quantity', sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.ORDER_QUANTITY
        },
        {
          itemKey: 'amount', isAvailable: true, isActive: true,
          type: 'Number', label: '金額' + taxlabel, path: 'node.amount' + taxMode, sortable: 'custom', class: 'right',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.ORDER_AMOUNT
        }
      ]
      return returnValue.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1)
    },
    sumTableRows () {
      return this.sumDataList(this.sortedList)
    },
    sumDisplayRows () {
      const sumLabels = [
        {
          itemKey: 'orderCnt', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '合計 注文件数', path: 'sumOrderCnt',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.ORDER_CNT
        },
        {
          itemKey: 'quantity', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: '合計 数量', path: 'sumQuantity',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.ORDER_QUANTITY
        },
        {
          itemKey: 'amount', isAvailable: true, isActive: true, width: null,
          type: 'Number', label: this.isDisplayTax ? '合計 金額' + '(税込)' : '合計 金額' + '(税抜)',
          path: 'sumAmount',
          funcId: define.PermissionKeys.Report.Sales.Sales_yell_list.ORDER_AMOUNT
        }
      ]
      return sumLabels
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // ダウンロードが可能のとき、アクションを表示
      const tempThisComponent = this
      setTimeout(() => {
        tempThisComponent.showActionList = this.$isFunctionShown(_.get(tempThisComponent.$refs, 'download.toDownload.funcId', ''))
      }, 1)

      this.$store.dispatch({
        type: 'set',
        states: {
          'SalesYell/tableSetList': this._tableSetList
        }
      })
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  async beforeUpdate () {
    const labelMonth = this.tableSetList.filter(row => row.itemKey === 'groupUnitMonth')
    const labelDay = this.tableSetList.filter(row => row.itemKey === 'groupUnitDay')
    const labelPaymentMethod = this.tableSetList.filter(row => row.itemKey === 'groupUnitPaymentMethod')
    const labelSite = this.tableSetList.filter(row => row.itemKey === 'groupUnitSite')

    // グループ単位（月、日、支払方法、サイト）列の表示切替
    // 検索条件の指定により、画面上の検索条件を修正後、税込計算ボタン押下で更新され、項目が表示される。
    // ただし、GraphQL側で取得していないため、項目値がブランクになる。
    labelMonth[0].isAvailable = this.conditions['groupUnit'].value.includes('0')
    labelMonth[0].isActive = this.conditions['groupUnit'].value.includes('0')
    labelDay[0].isAvailable = this.conditions['groupUnit'].value.includes('1')
    labelDay[0].isActive = this.conditions['groupUnit'].value.includes('1')
    labelPaymentMethod[0].isAvailable = this.conditions['groupUnit'].value.includes('2')
    labelPaymentMethod[0].isActive = this.conditions['groupUnit'].value.includes('2')
    labelSite[0].isAvailable = this.conditions['groupUnit'].value.includes('3')
    labelSite[0].isActive = this.conditions['groupUnit'].value.includes('3')

    // 商品コード、商品名、バリエーション名の表示切替
    const category0 = [true, true, true] // 販売商品別用
    const category1 = [true, true, false] // 商品別用
    const category2 = [false, false, false] // アーティスト別用
    const productCode = this.tableSetList.filter(row => row.itemKey === 'productCode')
    const productName = this.tableSetList.filter(row => row.itemKey === 'productName')
    const variationName = this.tableSetList.filter(row => row.itemKey === 'variationName')
    if (this.conditions['category'].value === '0') {
      // 販売商品別
      productCode[0].isAvailable = category0[0]
      productCode[0].isActive = category0[0]
      productName[0].isAvailable = category0[1]
      productName[0].isActive = category0[1]
      variationName[0].isAvailable = category0[2]
      variationName[0].isActive = category0[2]

      // 検索条件の切り替え
      this.conditions['skuCode'].display = true
      this.conditions['skuName'].display = true
      this.conditions['productCode'].display = true
      this.conditions['productName'].display = true
      this.conditions['skuCode'].canSelect = true
      this.conditions['skuName'].canSelect = true
      this.conditions['productCode'].canSelect = true
      this.conditions['productName'].canSelect = true
    } else if (this.conditions['category'].value === '1') {
      // 商品別
      productCode[0].isAvailable = category1[0]
      productCode[0].isActive = category1[0]
      productName[0].isAvailable = category1[1]
      productName[0].isActive = category1[1]
      variationName[0].isAvailable = category1[2]
      variationName[0].isActive = category1[2]

      // 検索条件の切り替え
      this.conditions['skuCode'].display = false
      this.conditions['skuName'].display = false
      this.conditions['productCode'].display = true
      this.conditions['productName'].display = true
      this.conditions['skuCode'].canSelect = false
      this.conditions['skuName'].canSelect = false
      this.conditions['productCode'].canSelect = true
      this.conditions['productName'].canSelect = true
    } else if (this.conditions['category'].value === '2') {
      // アーティスト別
      productCode[0].isAvailable = category2[0]
      productCode[0].isActive = category2[0]
      productName[0].isAvailable = category2[1]
      productName[0].isActive = category2[1]
      variationName[0].isAvailable = category2[2]
      variationName[0].isActive = category2[2]

      // 検索条件の切り替え
      this.conditions['skuCode'].display = true
      this.conditions['skuName'].display = true
      this.conditions['productCode'].display = false
      this.conditions['productName'].display = false
      this.conditions['skuCode'].canSelect = true
      this.conditions['skuName'].canSelect = true
      this.conditions['productCode'].canSelect = false
      this.conditions['productName'].canSelect = false
    }
  },
  methods: {
    displayTax: function () {
      const btn = document.getElementById('displayTax')
      if (this.isDisplayTax) {
        this.isDisplayTax = false
        btn.textContent = '税込計算'
      } else {
        this.isDisplayTax = true
        btn.textContent = '税抜計算'
      }

      const taxMode = (this.isDisplayTax ? 'Gross' : 'Net')
      // リロード対象のパラメータを設定する
      for (const tableSetItem of this.tableSetList) {
        if (tableSetItem.itemKey === 'amount') {
          tableSetItem.path = 'node.amount' + taxMode
          tableSetItem.label = this.isDisplayTax ? '金額' + '(税込)' : '金額' + '(税抜)'
        }
      }
      return this.tableSetList.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1)
    },
    // 合計算出
    sumDataList: function (sortedItems) {
      // 初期化
      let sumAmountGross = 0
      let sumAmountNet = 0
      let sumQuantity = 0
      let sumOrderCnt = 0
      // 合計算出（金額）
      for (const row of sortedItems) {
        sumAmountGross += row.node.amountGross
        sumAmountNet += row.node.amountNet
        sumQuantity += row.node.quantity
        sumOrderCnt += row.node.orderCnt
      }
      // 税抜/税込切り替え
      let dipsSumAmount = (this.isDisplayTax ? sumAmountGross : sumAmountNet)

      // 格納データセット
      let sumData = [{ sumOrderCnt: sumOrderCnt.toLocaleString(), sumQuantity: sumQuantity.toLocaleString(), sumAmount: dipsSumAmount.toLocaleString() }]

      // 暫定対応(検索条件の出し分けの有効化)
      if (this.conditions['category'].value === '3') {
      }

      return sumData
    }
  }
}
</script>

<style scoped>
  .prefixTableRow .el-button {
    text-align: center;
    margin-bottom: 10px;
  }
  .prefixTableRow .el-button ::v-deep span {
    margin: 0px;
  }
  .base-list-page ::v-deep .description .cell .inner-cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
</style>
